export default {
    CODA: 'Coda',
    INVOICE : 'invoice',
    PROCESSING_FEES : 'processing_fees',
    USER_LIST : 'user_list',
    N43: 'N43',
    FRA : 'fra',
    REPOSITORY_SHOP : 'repository_shop',
    TRANSACTION : 'Transaction',
    RELRIS : 'rerils'
}


// WEBPACK FOOTER //
// ./src/enums/JobType.js